import { Layout } from '@/utils/routerHelper'

// Survey menu routes come from the server. Keep the creation flow reachable
// when a page is opened directly or the dynamic menu has not loaded yet.
const surveyRoutes: AppRouteRecordRaw[] = [
  {
    path: '/survey',
    component: Layout,
    name: 'SurveyDirectRoutes',
    meta: { hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/survey/dashboard/index.vue'),
        name: 'SurveyDashboardDirect',
        meta: { hidden: true, canTo: true, title: '概况' }
      },
      {
        path: 'overview/dashboard',
        redirect: '/survey/overview',
        name: 'SurveyLegacyDashboardRedirect',
        meta: { hidden: true, canTo: true }
      },
      {
        path: 'overview',
        component: () => import('@/views/survey/overview/index.vue'),
        name: 'SurveyOverviewDirect',
        meta: { hidden: true, canTo: true, title: '概况' }
      },
      {
        path: 'decoration',
        component: () => import('@/views/survey/decoration/index.vue'),
        name: 'SurveyDecorationDirect',
        meta: { hidden: true, canTo: true, title: '页面装修' }
      },
      {
        path: 'design/manage',
        component: () => import('@/views/survey/manage/index.vue'),
        name: 'SurveyDesignManageDirect',
        meta: { hidden: true, canTo: true, title: '问卷管理', activeMenu: '/survey/design/manage' }
      },
      {
        path: 'editor',
        component: () => import('@/views/survey/editor/index.vue'),
        name: 'SurveyEditorDirect',
        meta: { hidden: true, canTo: true, title: '问卷编辑器', activeMenu: '/survey/create' }
      },
      {
        path: 'create',
        component: () => import('@/views/survey/create/index.vue'),
        name: 'SurveyCreateDirect',
        meta: { hidden: true, canTo: true, title: '创建问卷' }
      },
      {
        path: 'templates',
        component: () => import('@/views/survey/templates/index.vue'),
        name: 'SurveyTemplatesDirect',
        meta: { hidden: true, canTo: true, title: '问卷模板', activeMenu: '/survey/create' }
      },
      {
        path: 'publish',
        component: () => import('@/views/survey/publish/index.vue'),
        name: 'SurveyPublishDirect',
        meta: { hidden: true, canTo: true, title: '投放与回收', activeMenu: '/survey/publish' }
      },
      {
        path: 'import',
        component: () => import('@/views/survey/import/index.vue'),
        name: 'SurveyImportDirect',
        meta: { hidden: true, canTo: true, title: '导入问卷', activeMenu: '/survey/create' }
      },
      {
        path: 'analysis/response',
        component: () => import('@/views/survey/response/index.vue'),
        name: 'SurveyResponseDirect',
        meta: { hidden: true, canTo: true, title: '答卷管理', activeMenu: '/survey/analysis/response' }
      },
      {
        path: 'analysis/overview',
        component: () => import('@/views/survey/analysis/overview/index.vue'),
        name: 'SurveyAnalysisOverviewDirect',
        meta: { hidden: true, canTo: true, title: '数据概览', activeMenu: '/survey/analysis/overview' }
      }
    ]
  }
]
export default surveyRoutes
